import React from "react";
import { SessionSectionTime } from "../types";
import { formatSectionName, formatDuration } from "../utils/analytics";

interface SessionSectionTimeDetailsProps {
  sessionId: string;
  sectionTimes: SessionSectionTime[];
  totalSessionDuration: number;
}

const SessionSectionTimeDetails: React.FC<SessionSectionTimeDetailsProps> = ({
  sessionId,
  sectionTimes,
  totalSessionDuration,
}) => {
  if (sectionTimes.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-sm text-neutral-500">
          Brak danych o sekcjach dla tej sesji
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl">
      <h4 className="text-sm font-medium text-neutral-900 mb-3">
        Czas spędzony w sekcjach podczas tej sesji
      </h4>
      <div className="space-y-2">
        {sectionTimes.map((section) => (
          <div
            key={section.sectionName}
            className="flex items-center justify-between"
          >
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-primary-500 rounded-full"></div>
              <span className="text-sm text-neutral-700">
                {formatSectionName(section.sectionName)}
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-sm text-neutral-900">
                {formatDuration(Math.round(section.timeMs / 1000))}
              </span>
              <span className="text-sm font-medium text-primary-600 w-12 text-right">
                {section.percentage.toFixed(1)}%
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SessionSectionTimeDetails;
